import AppState from '../app-state';
import Collection from '@repo/utils/models/Collection';
import { Moments } from '@repo/utils/models/Moments';
import type { ID, ReduxAction } from '@repo/utils/types';
import Occasion from '@repo/utils/helpers/Occasion';

export interface MomentsState {
  collection: Collection<Moments>;
}

const initialMomentsState = {
  collection: new Collection<Moments>(),
};

/* Selectors */
export const selectContactMoments = (contactID: ID) => (state: AppState) =>
  state.data.moments.collection.items.get(String(contactID), new Moments());

export const selectContactInteractionsSummary = (contactID: ID) => (state: AppState) =>
  selectContactMoments(contactID)(state).summary;

export function momentsReducer(
  state: MomentsState = initialMomentsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_MOMENTS_REQUESTED':
      return {
        ...state,
        collection: state.collection.copyWith({
          items: state.collection.items.update(
            String(payload.id),
            new Moments({ isFetching: true }),
            (summary) => summary.copyWith({ isFetching: true, error: false }),
          ),
        }),
      };

    case 'FETCH_MOMENTS_SUCCEEDED':
      return {
        ...state,
        collection: state.collection.copyWith({
          items: state.collection.items.set(
            String(payload.requestID),
            new Moments({ ...payload.response, updated: new Occasion() }),
          ),
        }),
      };

    case 'FETCH_MOMENTS_FAILED':
      return {
        ...state,
        collection: state.collection.copyWith({
          items: state.collection.items.update(String(payload.contactID), (summary) =>
            summary?.copyWith({ isFetching: false, error: true }),
          ),
        }),
      };

    default:
      return state;
  }
}
